module.exports = __webpack_public_path__ + "static/img/atlas3.a3ba184c.jpg";